/* Zouq: add-to-cart without leaving the page for small '+ Add' forms */
(function () {
  var SEL = '.zq-pairs form[action="/cart/add"], .zq-mini-add form[action="/cart/add"], .zq-upsell form[action="/cart/add"]';
  function visible(el) { return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length)); }
  function openCart() {
    var icons = [].slice.call(document.querySelectorAll('[data-cart-sidebar]')).filter(visible);
    if (icons[0]) icons[0].click();
  }
  function bubbles(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
      var t = b.querySelector('[aria-hidden="true"], .text') || b; t.textContent = count;
    });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches(SEL) || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'), label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (btn) { btn.textContent = 'Added \u2713'; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 2000); }
        if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        bubbles(cart.item_count);
        if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) window.sharedFunctions.updateSidebarCart(cart);
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        if (!document.body.classList.contains('cart-sidebar-show')) setTimeout(openCart, 150);
      })
      .catch(function () { if (btn) { btn.innerHTML = label; btn.disabled = false; } form.submit(); });
  });
})();

/* Zouq: quick-shop popup: load its image and tag the most popular options */
(function () {
  var TAGS = { '500-G': 'Popular', 'Mustard Oil': 'Popular', 'Saver Pouch': 'Kam qeemat' };
  function enhance(root) {
    root.querySelectorAll('img[data-srcset]').forEach(function (i) { i.setAttribute('srcset', i.getAttribute('data-srcset')); i.setAttribute('sizes', '300px'); i.classList.remove('lazyload'); });
    var oils = [].map.call(root.querySelectorAll('input.product-form__radio'), function (x) { return x.value; });
    if (oils.indexOf('Mustard Oil') < 0 || oils.indexOf('Olive Oil') < 0) return;
    root.classList.add('zq-quick-tagged');
    root.querySelectorAll('input.product-form__radio').forEach(function (inp) {
      var t = TAGS[inp.value], lab = inp.nextElementSibling;
      if (t && lab && !lab.classList.contains('zq-tag')) { lab.classList.add('zq-tag'); lab.setAttribute('data-zq-tag', t); }
    });
  }
  new MutationObserver(function () {
    var q = document.querySelector('.halo-quickshop-popup .productView.quickshop');
    if (q && !q.dataset.zqDone && q.querySelector('input.product-form__radio')) { q.dataset.zqDone = '1'; enhance(q); }
    else if (q && q.dataset.zqDone && !q.querySelector('.zq-tag') && q.querySelector('input.product-form__radio')) { q.dataset.zqDone = ''; }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Zouq: Rs 25,000 per-order limit; bigger orders go to call / WhatsApp */
(function () {
  var LIMIT = 2500000, PHONE = '0313-3255557', WA = '923133255557';
  function rs(p) { return 'Rs ' + Math.round(p / 100).toLocaleString('en-US'); }
  function show(total) {
    var old = document.querySelector('.zq-limit-modal'); if (old) old.remove();
    var m = document.createElement('div'); m.className = 'zq-limit-modal';
    m.innerHTML = '<div class="zq-limit" role="dialog" aria-modal="true"><p class="zq-limit__t">Bulk order? Humein contact karein</p>' +
      '<p>Website par aik order Rs 25,000 tak ho sakta hai. Aap ka cart ' + rs(total) + ' hai.</p>' +
      '<p>Bulk order ke liye call ya WhatsApp karein: <a href="tel:+' + WA + '">' + PHONE + '</a></p>' +
      '<a class="zq-limit__wa" target="_blank" rel="noopener" href="https://wa.me/' + WA + '?text=' + encodeURIComponent('Assalam o Alaikum! Mujhe bulk order karna hai. Cart: ' + rs(total)) + '">WhatsApp par bulk order karein</a>' +
      '<button type="button" class="zq-limit__close">Cart kam karein</button></div>';
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('.zq-limit__close')) m.remove(); });
    document.body.appendChild(m);
  }
  var SEL = '.button-checkout, [name="checkout"], a[href*="/checkout"]';
  function guard(e, el) {
    if (!el || el.dataset.zqOk === '1' || !window.fetch) return;
    e.preventDefault(); e.stopImmediatePropagation();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (c.total_price > LIMIT) { show(c.total_price); return; }
      el.dataset.zqOk = '1'; el.click(); setTimeout(function () { el.dataset.zqOk = ''; }, 4000);
    }).catch(function () { el.dataset.zqOk = '1'; el.click(); });
  }
  document.addEventListener('click', function (e) { if (e.target.closest) guard(e, e.target.closest(SEL)); }, true);
  document.addEventListener('submit', function (e) { var s = e.submitter; if (s && s.matches && s.matches(SEL)) guard(e, s); }, true);
})();

/* Zouq: cart swap card: one 500g pickle -> Saver Pack / Pack of 3 (add the pack first, then remove the item) */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-zq-swap]');
    if (!b || !window.fetch || b.disabled) return;
    e.preventDefault(); b.disabled = true; var label = b.textContent; b.textContent = '...';
    var props = {}; try { props = JSON.parse(b.getAttribute('data-props') || '{}'); } catch (x) {}
    var J = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    fetch('/cart/add.js', { method: 'POST', headers: J, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-id'), quantity: 1, properties: props }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart/change.js', { method: 'POST', headers: J, body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: 0 }) }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        document.querySelectorAll('.cart-count-bubble').forEach(function (x) { var t = x.querySelector('[aria-hidden="true"], .text') || x; t.textContent = cart.item_count; });
        if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) window.sharedFunctions.updateSidebarCart(cart);
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
      })
      .catch(function () { b.disabled = false; b.textContent = label; });
  });
})();
